var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_c('div',{staticClass:"loading-spinner-container"},[_c('div',{staticClass:"loading-spinner"}),_c('p',[_vm._v("Loading...")])]):_c('div',[_c('h1',[_vm._v("Welcome!")]),_c('p',[_vm._v("Token validation successful. Redirecting...")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }